// O APP PAGO COM 7 DIAS GRÁTIS (Wesley, 01/11/2026), na interface nova:
//   - BloqueioPro: o paywall DURO, tela cheia, quando o teste acabou sem Pro.
//     Sem teste (TESTE_DIAS=0, 02/11/2026, motivo 'assinatura'): é o passo
//     seguinte ao cadastro — "Falta só assinar", com a garantia de 7 dias, e a
//     compra abre sozinha quando a pessoa veio do "Assinar" da página de assinar.
//     Só ficam assinar (lojas), restaurar, sair, excluir a conta (Apple 5.1.1.v)
//     e o suporte. No site não se vende: "Assine pelo app" com as lojas.
//     Nada se apaga — assinando, tudo volta na hora.
//   - AvisoTeste: "Teste grátis: faltam N dias", discreto; nos 2 últimos dias,
//     um convite mais claro para assinar.
// O estado vem do servidor (server/acesso-app.js, em /api/interface).
import React, { useState } from 'react';
import { api, type AcessoApp } from '../../services/apiV2';
import { SINGLE_PLAN } from '../plans';
import { isNativeApp } from '../platform';
import { IOSCheckoutButton, manageSubsCopy } from '../paywall';
import { LojasDoApp, LINHA_SO_LOJAS } from '../baixar-app';
import { DeleteAccountSheet } from '../profile';
import { Icon } from '../icons';
import { PRO_NOME, usePrecosPro } from './pro';
import './nova.css';

export const SUPORTE = 'contato@forjamente.com.br';

export const BloqueioPro: React.FC<{
  session: any;
  email?: string;
  /** Lê /api/interface de novo (depois da compra ou do restaurar). */
  onConferir: () => Promise<void> | void;
  onSair: () => void;
  onExcluir: () => Promise<void>;
  /** 'assinatura' = a conta nova sem teste (o app só para assinantes). */
  motivo?: string | null;
  garantiaDias?: number | null;
  /** Abre a compra da loja sozinho (veio do "Assinar" antes do cadastro). */
  autoAssinar?: boolean;
}> = ({ session, email, onConferir, onSair, onExcluir, motivo, garantiaDias, autoAssinar }) => {
  const semTeste = motivo === 'assinatura';
  const precos = usePrecosPro();
  const nativo = isNativeApp();
  const [excluir, setExcluir] = useState(false);
  const [conferindo, setConferindo] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);

  // A loja confirmou: o servidor grava o plano (sync-plan) e a tela some.
  const assinou = async () => {
    await api.syncRcPlan(session).catch(() => null);
    await onConferir();
  };
  const restaurar = async () => {
    setConferindo(true); setAviso(null);
    await api.syncRcPlan(session).catch(() => null);
    await onConferir();
    setConferindo(false);
    setAviso(`Não achamos uma assinatura ativa nesta conta. Assinou com outro e-mail? Escreva para ${SUPORTE}.`);
  };

  return (
    <div className="nv nv-bloqueio" data-tela="bloqueio-pro" role="dialog" aria-label={`${PRO_NOME}: assine para continuar`}>
      <div className="nv-bloqueio-hero nv-entra">
        <span className="nv-mono" style={{ color: 'var(--ember)' }}>{PRO_NOME}</span>
        {semTeste ? (
          <>
            <h1 className="nv-serif">Falta só <em>assinar.</em></h1>
            <p className="nv-sub">A sua conta está criada. Assine o Pro para abrir as trilhas, as notas do Mentor, os desafios e o Caderno.</p>
          </>
        ) : (
          <>
            <h1 className="nv-serif">O seu teste grátis <em>terminou.</em></h1>
            <p className="nv-sub">Assine o Pro para continuar. As suas notas, o caderno e o registro da leitura estão guardados: assinando, tudo volta na hora.</p>
          </>
        )}
      </div>

      <section className="nv-bloqueio-preco nv-entra nv-entra-2" data-bloqueio-preco>
        <div className="nv-pro-valor"><b className="nv-serif">{precos.ano}</b><span>por ano</span></div>
        <p>{precos.porMes ? `Menos de ${precos.porMes} por mês. ` : ''}Todas as trilhas, o Mentor lendo junto, os desafios e o caderno de aplicação.</p>
        {semTeste && !!garantiaDias && (
          <p className="nv-bloqueio-garantia" data-bloqueio-garantia={garantiaDias}><b>{garantiaDias} dias de garantia:</b> não gostou, peça o reembolso.</p>
        )}
      </section>

      <section className="nv-bloqueio-loja nv-entra nv-entra-3" data-bloqueio-loja={nativo ? 'nativo' : 'site'}>
        {nativo ? (
          <>
            {/* O botão da loja (RevenueCat) traz o "Restaurar compras anteriores". */}
            <div data-assinar-pro>
              <IOSCheckoutButton plan={SINGLE_PLAN} period="year" storePriceLabel={precos.ano} onSuccess={assinou} autoIniciar={!!autoAssinar} />
            </div>
            <p className="nv-bloqueio-letras">Assinatura anual, renova automaticamente ao fim do período. {manageSubsCopy()}</p>
            <p className="nv-bloqueio-letras">
              <a href="https://forjamente.com.br/termos" target="_blank" rel="noopener noreferrer">Termos de Uso</a>
              {' · '}
              <a href="https://forjamente.com.br/privacidade" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
            </p>
          </>
        ) : (
          <>
            <b className="nv-serif nv-bloqueio-titulo" data-assine-pelo-app>Assine pelo app</b>
            <p>{LINHA_SO_LOJAS} {precos.ano} por ano.</p>
            <LojasDoApp de="bloqueio" escuro />
            <button className="nv-bloqueio-restaurar" onClick={restaurar} disabled={conferindo} data-restaurar>
              {conferindo ? 'Conferindo…' : 'Já assinei: restaurar compra'}
            </button>
          </>
        )}
        {aviso && <p className="nv-bloqueio-aviso" role="status" data-restaurar-aviso>{aviso}</p>}
      </section>

      <div className="nv-bloqueio-conta">
        <button className="nv-secundario" onClick={onSair} data-bloqueio-sair><Icon name="log-out" size={16} />Sair da conta</button>
        {semTeste && <a className="nv-link" href="/suporte#reembolso" target="_blank" rel="noopener noreferrer" data-bloqueio-reembolso>Como pedir o reembolso</a>}
        <a className="nv-link" href={`mailto:${SUPORTE}?subject=${encodeURIComponent('Forjamente: preciso de ajuda com a assinatura')}`} data-bloqueio-suporte>Falar com o suporte · {SUPORTE}</a>
        <button className="nv-link nv-bloqueio-excluir" onClick={() => setExcluir(true)} data-bloqueio-excluir>Excluir a minha conta</button>
      </div>

      {excluir && <DeleteAccountSheet email={email} onClose={() => setExcluir(false)} onConfirm={onExcluir} />}
    </div>
  );
};

/** "Teste grátis: faltam N dias". Nos 2 últimos dias vira convite (com o botão).
 *  Antes da 1ª página registrada: "7 dias grátis: contam da 1ª página". */
export const AvisoTeste: React.FC<{ acesso: AcessoApp | null; onAssinar: () => void; onde: string }> = ({ acesso, onAssinar, onde }) => {
  const { ano } = usePrecosPro();
  if (!acesso || acesso.estado !== 'teste' || acesso.dias_restantes == null) return null;
  const n = Math.max(1, acesso.dias_restantes);
  // Ainda sem a 1ª página: os dias não começaram a contar.
  if (acesso.motivo === 'espera') {
    return (
      <button className="nv-aviso-teste nv-mono" onClick={onAssinar} data-aviso-teste={onde} data-dias={n} data-aviso-espera>
        <i />{n} dias grátis: contam da 1ª página
      </button>
    );
  }
  const falta = n === 1 ? 'falta 1 dia' : `faltam ${n} dias`;
  if (n > 2) {
    return (
      <button className="nv-aviso-teste nv-mono" onClick={onAssinar} data-aviso-teste={onde} data-dias={n}>
        <i />Teste grátis: {falta}
      </button>
    );
  }
  return (
    <button className="nv-aviso-teste forte" onClick={onAssinar} data-aviso-teste={onde} data-dias={n} data-aviso-forte>
      <span className="nv-mono"><i />Teste grátis: {n === 1 ? 'último dia' : falta}</span>
      <b className="nv-serif">Assine o Pro para não parar a leitura.</b>
      <small>{ano} por ano. As suas notas e o caderno continuam seus.</small>
      <Icon name="arrow-right" size={18} />
    </button>
  );
};
